package com.appcreator.blueprint.conversions

import com.appcreator.blueprint.core.Conversion
import kotlinx.serialization.Serializable

@Serializable
class UnsupportedConversion : Conversion
